import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from 'core/store/authStore';
import { getDashboardRoute } from 'core/router/routes';

const Unauthorized = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();

  const handlePrimaryAction = () => {
    if (isAuthenticated && user) {
      navigate(getDashboardRoute(user.role));
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4 font-display">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-amber-100 rounded-3xl mb-6">
          <span
            className="material-symbols-outlined text-amber-500 text-4xl"
            style={{ fontVariationSettings: '"FILL" 1' }}
          >
            lock
          </span>
        </div>

        <p className="text-8xl font-black text-amber-500 tracking-tighter mb-2">401</p>

        <h1 className="text-2xl font-bold text-slate-900 mb-3">Access denied</h1>

        <p className="text-slate-500 max-w-sm mx-auto mb-8">
          You don't have permission to view this page. Try logging in with a different account.
        </p>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={handlePrimaryAction}
            className="inline-flex items-center gap-2 bg-primary text-white font-semibold px-5 py-2.5 rounded-xl hover:bg-primary-deep transition-colors"
          >
            <span className="material-symbols-outlined text-[18px]">dashboard</span>
            {isAuthenticated ? 'Go to dashboard' : 'Log in'}
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 border border-slate-200 text-slate-700 font-semibold px-5 py-2.5 rounded-xl hover:bg-slate-50 transition-colors"
          >
            <span className="material-symbols-outlined text-[18px]">home</span>
            Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
